import * as React from "react";
import { ManageableQuickscanData } from "../types";
import { QuickscanDataContext } from "../context/QuickscanDataContext";
import { StepOne } from "./StepOne";
import { StepTwo } from "./StepTwo";
import { StepThree } from "./StepThree";
import { StepFour } from "./StepFour";

export const Steps = () => {

    const [quickscanDataState, quickscanDataDispatch] = React.useContext<ManageableQuickscanData>(QuickscanDataContext);

    if(quickscanDataState.finished) {
        return <div></div>;
    }

    return <div className={'c-quickscan__steps'}>

        {quickscanDataState.currentStep === 0 && <StepOne/>}
        {quickscanDataState.currentStep === 1 && <StepTwo/>}
        {quickscanDataState.currentStep === 2 && <StepThree/>}
        {quickscanDataState.currentStep === 3 && <StepFour/>}

    </div>;

}
